<template>
  <div class="result">
    <v-row>
      <v-col cols="12" sm="4">
        <p class="text-h6 mb-0 mb-sm-4">コース結果登録</p>
      </v-col>
      <v-col v-if="campaign.is_prize" cols="12" sm="8" style="display:flex;justify-content:flex-end;" class="pt-0 pt-sm-3 mb-3 pb-sm-5">
        <div class="prizewinner-label">達成賞状況</div>
        <div v-if="(campaignUser.is_prizewinner || isAppPrizewinner) && isContinueBonusComp && campaign.is_continue_bonus" class="custom-alert is-prizewinner">
          現在、達成賞 + 継続ボーナスの対象です。
        </div>
        <div v-else-if="(campaignUser.is_prizewinner || isAppPrizewinner) && campaign.is_continue_bonus" class="custom-alert is-prizewinner">
          現在、達成賞のみ対象です。
        </div>
        <div v-else-if="campaignUser.is_prizewinner || isAppPrizewinner" class="custom-alert is-prizewinner">
          現在、達成賞の対象です。
        </div>
        <div v-else class="custom-alert is-not-prizewinner">
          現在、達成賞の対象ではありません。
        </div>
      </v-col>
    </v-row>
    <v-sheet
      outlined
      elevation="1"
    >
      <v-tabs
        class="kenchare-tab"
        v-model="tab"
        background-color="primary"
        fixed-tabs
        dark
        icons-and-text
        slider-size="10"
      >
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab>
          <p>記録の入力</p>
          <v-icon>mdi-calendar-check</v-icon>
        </v-tab>
        <v-tab>
          <p>達成状況の確認</p>
          <v-icon>mdi-chart-areaspline-variant</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="pa-2">
        <v-tab-item class="mt-4">
          <ResultTopic :campaignUser="campaignUser" :isSelectedWalkingCourse="isSelectedWalkingCourse" :dailyValueList="dailyValueList" :numberOfSteps="numberOfSteps"/>
          <v-divider v-if="isRegisteredCourse" class="mx-5"></v-divider>
          <ResultInput v-if="isRegisteredCourse" :campaignUser="campaignUser" :propsDailyValueList="dailyValueList" @fetchData="getDailyResultList" @inputError="inputError" />
        </v-tab-item>
        <v-tab-item class="mt-4">
          <ResultConfirm :campaignUser="campaignUser" :propsDailyValueList="dailyValueList"/>
        </v-tab-item>
      </v-tabs-items>
      <v-snackbar
        v-model="showSnackBar"
        color="info"
        top
      >
        {{ message }}
        <template v-slot:action="{ attrs }">
          <v-btn
            icon
            color="white"
            v-bind="attrs"
            @click="showSnackBar = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-sheet>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
const ResultTopic = () => import('./ResultTopic')
const ResultInput = () => import('./ResultInput')
const ResultConfirm = () => import('./ResultConfirm')

const listDailyResultQuery = (campaignId) => `
  query listDailyResult {
    listDailyResult(campaign_id: "${campaignId}") {
      campaign_id
      select_course_list {
        id
        meta
        name
        result_type
        unit
        complete_type
        complete_value
        category
        objective
        basic_item
        recording_method
        detailed_document_file_name
        youtube_url
        youtube_thumbnail_file_name
        aggregate
        participants
        is_display_graph
        custom_goal_setting
        aggregate_result_info {
          id
          course_id
          point
          input_count
          total
          average
          rank
          custom_objective
          clear_count
          is_completed
        }
      }
      daily_results {
        id
        meta
        is_inputted
        top_blood_pressure
        bottom_blood_pressure
        note
        select_course_result {
          id
          meta
          course_id
          circle_and_cross
          integer
          number
          is_manual
        }
      }
    }
  }
`
const getListDailyResult = async (campaignId) => {
  const { data: { listDailyResult: data } } = await GraphqlAPI(listDailyResultQuery(campaignId))
  return data
}

const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      is_app_completed
      is_no_smoking_completed
      is_continue_bonus_complete
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return {
    is_app_completed: data.is_app_completed,
    is_no_smoking_completed: data.is_no_smoking_completed,
    is_continue_bonus_complete: data.is_continue_bonus_complete
  }
}

export default {
  name: 'result',
  data () {
    return {
      tab: null,
      dailyValueList: null,
      showSnackBar: false,
      message: null,
      isAppPrizewinner: false,
      isContinueBonusComp: false,
      isSelectedWalkingCourse: false,
      numberOfSteps: 0
    }
  },
  props: ['campaignUser'],
  components: {
    ResultTopic,
    ResultInput,
    ResultConfirm
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    isRegisteredCourse () {
      return this.$store.getters.getRegisteredCourse
    }
  },
  watch: {
    dailyValueList: {
      handler (newValue) {
        if (newValue !== null) {
          for (const course of this.dailyValueList.select_course_list) {
            if (course.unit === '歩' &&
              course.aggregate_result_info.total !== null &&
              this.numberOfSteps !== course.aggregate_result_info.total
            ) {
              this.numberOfSteps = course.aggregate_result_info.total
            }
          }
        }
      },
      deep: true
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    await this.fetchUserViewData()
    await this.fetchListDailyResult()
  },
  async mounted () {
    // 指定ページからの遷移後処理
    if (this.$route.params.referer) {
      if (this.$route.params.referer === 'update_course') {
        this.message = 'コースが保存されました。'
        this.showSnackBar = true
        this.$route.params.referer = ''
      } else if (this.$route.params.referer === 'app_entry') {
        this.message = '食事バッチリ！アプリチャレンジコースにエントリーしました。'
        this.showSnackBar = true
        this.$route.params.referer = ''
      }
    }
  },
  methods: {
    async fetchListDailyResult () {
      try {
        this.dailyValueList = await getListDailyResult(this.campaign.id)
        for (const course of this.dailyValueList.select_course_list) {
          // ウォーキングコースの有無取得
          if (course.unit === '歩') {
            this.isSelectedWalkingCourse = true
            if (course.aggregate_result_info.total !== null) {
              this.numberOfSteps = course.aggregate_result_info.total
            }
          }
        }
      } catch (e) {
        this.$emit('errorHandling', '結果の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async fetchUserViewData () {
      try {
        const userviewInfo = await getUserViewInfo(this.campaign.id)
        this.isAppPrizewinner = userviewInfo.is_app_completed || userviewInfo.is_no_smoking_completed
        this.isContinueBonusComp = userviewInfo.is_continue_bonus_complete
      } catch (e) {
        this.$emit('errorHandling', '達成賞対象情報の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async getDailyResultList (childFunction) {
      try {
        this.dailyValueList = await getListDailyResult(this.campaign.id)
        this.$emit('fetchCampaignUser')
        childFunction()
      } catch (e) {
        this.$emit('errorHandling', '結果の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    inputError (errorMessage) {
      this.$emit('errorHandling', errorMessage)
    }
  }
}
</script>

<style scoped lang="scss">
.custom-alert {
  font-size: 0.9rem;
  font-weight: bold;
  padding: 3px 15px 1px 15px;
  border-radius: 3px;
}
.prizewinner-label {
  font-size:0.9rem;
  padding:3px 20px;
}
.is-not-prizewinner {
  background-color: #f5f5f5 !important;
  color: #4d4d4d;
  border: #4d4d4d solid 0.5px;
}
.is-prizewinner {
  background-color: #ffe6f0;
  color: #CC0058 !important;
  border: #CC0058 solid 0.5px;
}
</style>
